import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getPlatformProviders } from "@/services/platformApi/publicCatalogApi";
import { Provider } from "@/types/supabase";
import { useToast } from "@/hooks/use-toast";

/**
 * Custom hook to fetch and manage all service providers with optimized caching
 */
export function useProviders() {
  const { toast } = useToast();
  const queryClient = useQueryClient();

  // Use React Query to fetch all providers with improved caching strategy
  return useQuery({
    queryKey: ['allProviders'],
    queryFn: async () => {
      try {
        const providers = await getPlatformProviders();
        return providers as Provider[];
      } catch (error) {
        console.error("Error:", error);
        toast({
          title: "Error",
          description: "Failed to load provider data. Please try again later.",
          variant: "destructive",
        });
        return [];
      }
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes (was cacheTime)
    refetchOnWindowFocus: false, // Don't refetch on window focus
    refetchOnMount: true, // But do refetch on component mount
  });
}
